<template>
  <div>
    <div class="container">
      <el-page-header class="page-header" @back="goBack" content="配送信息"></el-page-header>
      <AreaHeader class="area-header-one" title="收件人信息" rightText="使用地址簿" @rightClick="toAddressList"></AreaHeader>
      <el-form label-width="120px" label-position="right" class="basic-info" v-model="deliveryFormData" v-show="addressInfoVisible">
        <el-form-item label="*姓名：" class="form-item">
            <el-input v-model="deliveryFormData.receiverName" ref="nameId" type="text" placeholder="请输入收件人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="*联系电话：" class="form-item">
            <el-input @wheel.native.prevent v-model="deliveryFormData.phoneNo" ref="phoneId" type="number" placeholder="请输入联系人手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item label="*省市区：" class="form-item">
            <el-cascader
            class="address-picker"
            ref='adressCas'
            :filterable="true"
            placeholder="请选择或搜索地址"
            @change="addressChange"
            :value="addressInfo"
            :options="areaOptions"></el-cascader>
            <span v-show="addressTemp&&addressTemp.length>0" style="position: absolute;color: #606266;background-color: white;left: 10px;line-height: 20px;width: 300px;text-align: start;font-size: 18px;">{{addressTemp}}</span>
        </el-form-item>
        <el-form-item label="*详细地址：" class="form-item">
            <el-input v-model="deliveryFormData.street" ref="customAddressId" type="text" placeholder="请输入详细地址(街道门牌信息)" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮政编码：" class="form-item">
            <el-input @wheel.native.prevent v-model="deliveryFormData.zipCode" type="number" placeholder="请输入邮政编码" clearable></el-input>
        </el-form-item>
      </el-form>
      <AreaHeader class="area-header-one" title="煎药信息"></AreaHeader>
      <el-form label-width="120px" label-position="right" class="basic-info" :model="drugFormData" @submit.native.prevent>
        <el-form-item class="radio-container" label="*中草药形态:">
            <el-radio-group class="radio-group" v-model="drugFormData.currentFormName" v-for="value in forms" :key="value.formCode" @change="radioChange">
                <el-radio-button class="radio-button" :label="value.formName" border>{{value.formName}}</el-radio-button>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="*几副药：" class="form-item">
            <el-input @wheel.native.prevent onke v-model="drugFormData.drugCount" ref="drugCountId"  type="number" autocomplete="off" placeholder="请输入几副药，只能是大于0的数字" @keyup.native.enter></el-input>
        </el-form-item>
        <div style="text-align: left;margin-left: 12%; color: #666;">请注意药方有效期</div>
        <el-form-item label="备注：" class="form-item" style="margin-top: 20px;">
            <el-input v-model="drugFormData.remark" type="textarea" placeholder="如有特殊需求请注明" autosize maxlength="100" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <AreaHeader class="area-header-one" title="开方信息"></AreaHeader>
      <el-collapse v-model="activeNames" class="collapse">
        <el-collapse-item class="collapse-item" name="1">
          <template slot="title">
              <div>
                  <label class="collapse-title">基本信息</label>
              </div>
          </template>
          <ul class="basic-info" v-if="consultInfo">
              <li><b>姓名：</b>{{consultInfo.name}}</li>
              <li><b>性别：</b>{{consultInfo.sex == '1'?'男':'女'}}</li>
              <li><b>电话：</b>{{consultInfo.phoneNo}}</li>
              <li><b>出生日期：</b>{{consultInfo.birthday}}</li>
              <li><b>常住地址：</b>{{consultInfo.liveArea}}</li>
              <li><b>出生地址：</b>{{consultInfo.birthArea}}</li>
              <li v-if="consultInfo.useDate"><b>开始服药时间：</b>{{consultInfo.useDate}}</li>
              <li v-if="consultInfo.useDays"><b>服药天数：</b>{{consultInfo.useDays}}</li>
          </ul>
        </el-collapse-item>
        <el-collapse-item name="2" class="collapse-item">
          <template slot="title">
              <div>
                  <label class="collapse-title">症状信息</label>
              </div>
          </template>
          <table border="1" class="basic-info basic-table">
              <tr class="table-rows" v-for="(item,index) in basicTableArray">
                  <td v-if="index == 0" :rowspan="basicTableArray.length">基本情况</td>
                  <td v-if="item.value">{{item.key}}</td>
                  <td v-if="item.value">{{item.value}}</td>
              </tr>
              <tr class="table-rows" v-for="(item1,index) in shangjiaoTableArray" v-if="hasShangJiao">
                  <td v-if="index == 0" :rowspan="shangjiaoTableArray.length">上焦</td>
                  <td v-if="item1.value">{{item1.key}}</td>
                  <td v-if="item1.value">{{item1.value.toString()}}</td>
              </tr>
              <tr class="table-rows" v-for="(item2,index) in zhongjiaoTableArray" v-if="hasZhongJiao">
                  <td v-if="index == 0" :rowspan="zhongjiaoTableArray.length">中焦</td>
                  <td v-if="item2.value">{{item2.key}}</td>
                  <td v-if="item2.value">{{item2.value.toString()}}</td>
              </tr>
              <tr class="table-rows" v-for="(item3,index) in xiajiaoTableArray" v-if="hasXiaJiao">
                  <td v-if="index == 0" :rowspan="xiajiaoTableArray.length">下焦</td>
                  <td v-if="item3.value">{{item3.key}}</td>
                  <td v-if="item3.value">{{item3.value.toString()}}</td>
              </tr>
          </table>
        </el-collapse-item>
        <el-collapse-item name="3" class="collapse-item">
          <template slot="title">
              <div>
                  <label class="collapse-title">药方信息</label>
              </div>
          </template>
          <h2>{{pane.title}}</h2>
            <table border="1" class="basic-info" style="margin-left: 20px;">
                <tr class="table-header">
                    <td>序号</td>
                    <td>药品</td>
                    <td>重量（克）</td>
                    <td>序号</td>
                    <td>药品</td>
                    <td>重量（克）</td>
                </tr>
                <tr class="table-rows" v-for="item in pane.options">
                    <td style="width: 8%;">
                      <span class="span-index" v-show="item.key">{{item.index}}</span>
                    </td>
                    <td style="width: 30%;">
                      <div class="item-row" v-show="item.key">
                        <span style="width: 100%; padding-left: 10%; text-align: left;">{{item.key}}</span>
                        <el-button @click="drugChangeClick(item,0)" style="width: 62px;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
                      </div>
                    </td>
                    <td style="width: 12%;">
                      <div class="item-row" v-show="item.key">
                        <span style="width: 100%; text-align: center;">{{item.value}}g</span>
                        <el-button  @click="drugWeightClick(item,0)" style="width: 62px;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
                      </div>
                    </td>
                    <td style="width: 8%;"><span v-show="item.key1" class="span-index">{{item.index1}}</span></td>
                    <td style="width: 30%;">
                      <div class="item-row" v-show="item.key1">
                        <span style="width: 100%; padding-left: 10%; text-align: left;">{{item.key1}}</span>
                        <el-button @click="drugChangeClick(item,1)" style="width: 25%;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
                      </div>
                    </td>
                    <td style="width: 12%;">
                      <div class="item-row" v-show="item.key1">
                        <span style="width: 100%; text-align: center;">{{item.value1}}g</span>
                        <el-button @click="drugWeightClick(item,1)" style="width: 62px;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
                      </div>
                    </td>
                </tr>
                <tr>
                    <td class="table-footer-td" colspan="6"><b>*</b>总计：<b>{{pane.count}}</b>味，<b>{{pane.totalWeight}}</b>克；<b v-show="pane.charge != 0" style="color: black;">参考药价：</b><b v-show="pane.charge != 0">{{pane.charge}}</b><b v-show="pane.charge != 0" style="color: black;">元/副</b></td>
                </tr>
                <tr class="table-footer" >
                    <td class="table-footer-td" colspan="6"><b>*</b>有效使用期：{{pane.startDate}} ~ {{pane.endDate}}</td>
                </tr>
            </table>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-button class="btn-confirm" type="primary" @click="submit">统一配送</el-button>
    <el-button class="btn-confirm" @click="saveDraft">保存草稿</el-button>
    <el-dialog title="确认信息是否正确" :visible.sync="dialogVisible" center destroy-on-close width="40%">
      <ul class="basic-info" style="margin-top: 0px;width:100%;">
          <li><b>病人姓名：</b>{{consultInfo.name}}</li>
          <li><b>中草药形态：</b>{{currentForm.formName}}</li>
          <li><b>几副药：</b>{{drugFormData.drugCount}}</li>
          <li><b>收件人姓名：</b>{{deliveryFormData.receiverName}}</li>
          <li><b>收件人联系方式：</b>{{deliveryFormData.phoneNo}}</li>
          <div class="dialog-div"><b>收件地址：</b>{{this.deliveryFormData.province+this.deliveryFormData.city+this.deliveryFormData.county+deliveryFormData.street}}</div>
          <li><b>备注：</b>{{drugFormData.remark != null && drugFormData.remark.length == 0?'无':drugFormData.remark}}</li>
      </ul>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" style="margin-right: 30px;">再看看</el-button>
          <el-button type="primary" @click="confirmOrder" style="margin-left: 30px;">确认提交</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  import AreaHeader from '@/components/widgets/area-header.vue'
  import WJTRadio from '@/components/widgets/wjt-radio.vue'
  import store from '../../store'
  import { EventBus } from "../../js/eventbus.js"
  export default {
    name:'fulConfirm',
    components:{
        AreaHeader,
        WJTRadio,
    },
    data () {
      return {
        forms:[],
        activeNames:'0',
        dialogVisible:false,
        currentForm:{},
        consultInfo:{},
        basicTableArray:[],
        shangjiaoTableArray:[],
        zhongjiaoTableArray:[],
        xiajiaoTableArray:[],
        tabActive:'',
        tablePrescription:[],
        prescription:{},
        drugFormData:{
          currentFormName:'',
          drugCount:'',
        },
        addressInfo:[],
        addressTemp:'',
        deliveryFormData:{
          receiverName:'',
          phoneNo:'',
          province:'',
          city:'',
          county:'',
          street:'',
          zipCode:'',
          remark:'',
        },
        pane:{},
        hasShangJiao:false,
        hasZhongJiao:false,
        hasXiaJiao:false,
        area: {},
        draftInfo:{},
        addressInfoVisible:false
      }
    },
    computed: {
        areaOptions() {
            var area = this.$store.state.areaInfo;
            if(!area || !Array.isArray(area.province_list)) return [];
            
            var provinces = [];
            var citiesMap = {}; 
            var countiesMap = {}; 
            
            // 1. Prepare Counties
            if(area.county_list){
                area.county_list.forEach(county => {
                    var cCode = county.parentAreaCode;
                    if(!countiesMap[cCode]) countiesMap[cCode] = [];
                    countiesMap[cCode].push({
                        value: county.areaCode,
                        label: county.name
                    });
                });
            }
            
            // 2. Prepare Cities
            if(area.city_list){
                area.city_list.forEach(city => {
                    var pCode = city.parentAreaCode;
                    if(!citiesMap[pCode]) citiesMap[pCode] = [];
                    
                    var cityNode = {
                        value: city.areaCode,
                        label: city.name
                    };
                    if(countiesMap[city.areaCode] && countiesMap[city.areaCode].length > 0) {
                        cityNode.children = countiesMap[city.areaCode];
                    }
                    citiesMap[pCode].push(cityNode);
                });
            }
            
            // 3. Prepare Provinces
            if(area.province_list){
                area.province_list.forEach(province => {
                    var pCode = province.areaCode;
                    var provinceNode = {
                        value: pCode,
                        label: province.name
                    };
                    if(citiesMap[pCode] && citiesMap[pCode].length > 0) {
                        provinceNode.children = citiesMap[pCode];
                    }
                    provinces.push(provinceNode);
                });
            }
            
            return provinces;
        }
    },
    mounted(){
      this.area = this.$store.state.areaInfo
      var mode = this.$route.query.mode
      var data = this.$store.getters.getFulfillmentConfirmData
      if(!this.utils.isEmptyObject(data)){
        this.drugFormData = data.drugFormData
        this.addressInfo = data.addressInfo
        if(data.addressInfo && data.addressInfo.length == 3){
          this.addressTemp = data.addressInfo[0]+'/'+data.addressInfo[1]+'/'+data.addressInfo[2]
        }
        if(!this.utils.isEmptyObject(data.currentForm)){
          this.currentForm = data.currentForm
        }
        this.deliveryFormData = data.deliveryFormData
      }
      this.prescription = JSON.parse(sessionStorage.getItem("prescription"))
      //从草稿列表进来时
      if(mode != 1){
        this.consultInfo = JSON.parse(sessionStorage.getItem('consultInfo'))
        this.basicTableArray = JSON.parse(sessionStorage.getItem('basicTable'))
        this.shangjiaoTableArray = JSON.parse(sessionStorage.getItem('shangjiaoTableArray'))
        this.zhongjiaoTableArray = JSON.parse(sessionStorage.getItem('zhongjiaoTableArray'))
        this.xiajiaoTableArray = JSON.parse(sessionStorage.getItem('xiajiaoTableArray'))
        this.tablePrescription = JSON.parse(sessionStorage.getItem('tablePrescription'))
        var that = this
        this.shangjiaoTableArray.forEach(function (element) {
            if(element.value.length > 0){
              that.hasShangJiao = true
            }
        })
        this.zhongjiaoTableArray.forEach(function (element) {
            if(element.value.length > 0){
              that.hasZhongJiao = true
            }
        })
        this.xiajiaoTableArray.forEach(function (element) {
            if(element.value.length > 0){
              that.hasXiaJiao = true
            }
        })
        console.log(this.prescription)
        var orderId = this.$route.query.orderId
        var index = this.$route.query.index
        this.pane = this.tablePrescription[index]
      }
      this.wjtHttp.get(this,'/api/medicine/v2/forms/'+this.prescription.type,{},false,(res)=>{
              var data = res.data
              if(data.code == 200){
                  this.forms = data.data
                  if(mode == 1){
                    this.getDraft()
                  }
              }else{
                  this.$message({
                      message:(data.msg&&data.msg.length > 0)?data.msg:'获取中草药形态异常',
                      type:'error'
                  })
              }
          },(err)=>{
              console.log(err)
          })
      var address = sessionStorage.getItem('selectAddress')
      // 获取我的地址
      if(address != null && address.length > 0){
        var addressObj = JSON.parse(address)
        this.deliveryFormData.receiverName = addressObj.receiverName
        this.deliveryFormData.phoneNo = addressObj.phoneNo
        this.deliveryFormData.province = addressObj.province
        this.deliveryFormData.city = addressObj.city
        this.deliveryFormData.county = addressObj.county
        this.addressInfo = addressObj.addressInfo
        this.deliveryFormData.street = addressObj.street
        this.deliveryFormData.zipCode = addressObj.zipCode
        this.addressTemp = addressObj.addressInfo[0]+'/'+addressObj.addressInfo[1]+'/'+addressObj.addressInfo[2]
        console.log("updateAddress:")
        console.log(this.deliveryFormData)
        this.addressInfoVisible = true
      }
      sessionStorage.removeItem('selectAddress')
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        },
        setDraftInfo(){
          this.currentForm = this.forms.find(item => item.formCode == this.draftInfo.form)
          this.drugFormData.currentFormName = this.currentForm.formName
          this.drugFormData.formCode = this.currentForm.formCode
          this.drugFormData.drugCount = this.draftInfo.formCount
          this.deliveryFormData.receiverName = this.draftInfo.recipientName
          this.deliveryFormData.phoneNo = this.draftInfo.recipientPhone
          this.deliveryFormData.zipCode = this.draftInfo.zipCode
          this.drugFormData.remark = this.draftInfo.remark
          this.deliveryFormData.province = this.draftInfo.province
          this.deliveryFormData.city = this.draftInfo.city
          this.deliveryFormData.county = this.draftInfo.county
          this.addressInfo = [this.draftInfo.province,this.draftInfo.city,this.draftInfo.county]
          this.deliveryFormData.street = this.draftInfo.street
          this.addressTemp = this.draftInfo.province+'/'+this.draftInfo.city+'/'+this.draftInfo.county
          this.$refs['adressCas'].panel.initStore()
        },
        getName(list, code){
            if(!list || !Array.isArray(list)) return '';
            let item = list.find(x => x.areaCode == code);
            return item ? item.name : '';
        },
        addressChange(e){
          console.log(e)
          if(e.length >= 2) {
            this.deliveryFormData.province = this.getName(this.area.province_list, e[0])
            this.deliveryFormData.city = this.getName(this.area.city_list, e[1])
            if(e.length >= 3){
                this.deliveryFormData.county = this.getName(this.area.county_list, e[2])
            } else {
                this.deliveryFormData.county = ''
            }
            this.addressTemp = ''
            this.addressInfo = e
          }
        },
        radioChange(){
          this.currentForm = this.forms.find(item => item.formName == this.drugFormData.currentFormName)
          console.log(this.drugFormData.currentFormName)
        },
        toAddressList(){
          this.$router.push({
            path:'/address',
            query:{
              mode:1
            }
          })
        },
        submit(){
          if(this.drugFormData.currentFormName.length == 0){
            this.$message("请选择一个中草药形态")
            return
          }
          if(this.drugFormData.drugCount <= 0 ){
            this.$nextTick(() => {
              this.$refs.drugCountId.focus();
            })
            this.$message("请输入几副药，只能是大于0的数字")
            return
          }
          if(this.deliveryFormData.receiverName.length == 0){
            this.$nextTick(() => {
              this.$refs.nameId.focus();
            })
            this.$message("请输入收件人姓名")
            return
          }
          if(this.deliveryFormData.phoneNo.length != 11){
            this.$nextTick(() => {
              this.$refs.phoneId.focus();
            })
            this.$message("请输入正确的11位手机号")
            return
          }
          if(this.addressInfo.length == 0){
            this.$message("请选择省市区")
            return
          }
          if(this.deliveryFormData.street.length == 0){
            this.$nextTick(() => {
              this.$refs.customAddress.focus();
            })
            this.$message("请输入详细地址")
            return
          }
          this.dialogVisible = true
        },
        confirmOrder(){
          this.dialogVisible = false
          this.wjtHttp.post(this,'/api/delivery/order/place',{
            deliveryType:"E",
            endDate:this.prescription.endDate,
            startDate:this.prescription.startDate,
            type:this.prescription.type,
            form: this.currentForm.formCode,
            remark: this.drugFormData.remark,
            formCount:this.drugFormData.drugCount,
            zipCode:this.deliveryFormData.zipCode,
            recipientAddress: this.deliveryFormData.province+this.deliveryFormData.city+this.deliveryFormData.county+this.deliveryFormData.street,
            recipientName: this.deliveryFormData.receiverName,
            recipientPhone: this.deliveryFormData.phoneNo,
            visitRecordId: this.prescription.visitRecordId
          },true,(res)=>{
                  var data = res.data
                  if(data.code == 200){
                      this.$router.replace({
                        path:'/fulfillmentOrder',
                        query:{
                          orderId:data.data.deliveryOrderId
                        }
                      })
                  }else{
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'生成统一配送订单异常',
                          type:'error'
                      })
                  }
              },(err)=>{
                  console.log(err)
              })
        },
        getDraft(){
          this.wjtHttp.post(this,'/api/delivery/order/draft/info',{
            endDate: this.prescription.endDate,
            startDate: this.prescription.startDate,
            type: this.prescription.type,
            visitRecordId: this.prescription.visitRecordId
          },true,(res)=>{
            if(res.data.data){
              this.draftInfo = res.data.data
              this.consultInfo = res.data.data.patient
              this.setDraftInfo()
              this.generateTableData()
            }
          },(err)=>{
          })
        },
        generateTableData(){
          var item = this.draftInfo.prescriptionInfo
          this.pane.count = item.count
          this.pane.charge = item.charge
          this.pane.totalWeight = item.totalWeight
          this.pane.startDate = item.startDate
          this.pane.endDate = item.endDate
          this.pane.title = item.name
          var itemArray = item.prescription
          for (var j = 0; j < itemArray.length;j++){
              var itemJ = itemArray[j]
              if(j%2 == 1){
                  itemArray[j-1].key1 = itemJ.key
                  itemArray[j-1].value1 = itemJ.value
                  itemArray[j-1].index1 = itemJ.index
                  itemArray[j-1].visible1 = false
              }else{
                itemArray[j].visible = false
              }
          }
          var options = []
          for (var k = 0; k < itemArray.length;k++){
              if(k%2 == 0){
                  options.push(itemArray[k])
              }
          }
          this.pane.options = options

          this.basicTableArray = this.basicTableArray.concat(this.draftInfo.inquiryInfo.basic_array)
          this.basicTableArray = this.basicTableArray.concat(this.draftInfo.inquiryInfo.basic_enter_array)
          this.basicTableArray = this.basicTableArray.concat(this.draftInfo.inquiryInfo.maixiang_array)
          this.shangjiaoTableArray = this.draftInfo.inquiryInfo.shangjiao_array
          this.zhongjiaoTableArray = this.draftInfo.inquiryInfo.zhongjiao_array
          this.xiajiaoTableArray = this.draftInfo.inquiryInfo.xiajiao_array
          var that = this
          this.shangjiaoTableArray.forEach(function (element) {
              if(element.value.length > 0){
                that.hasShangJiao = true
              }
          })
          this.zhongjiaoTableArray.forEach(function (element) {
              if(element.value.length > 0){
                that.hasZhongJiao = true
              }
          })
          this.xiajiaoTableArray.forEach(function (element) {
              if(element.value.length > 0){
                that.hasXiaJiao = true
              }
          })
        },
        //保存草稿
        saveDraft(){
          if(this.drugFormData.currentFormName.length == 0){
              this.$message("请选择一个中草药形态")
              return
            }
            if(this.drugFormData.drugCount.length == 0 || this.drugFormData.drugCount == 0){
              this.$nextTick(() => {
                this.$refs.drugCountId.focus();
              })
              this.$message("请输入几副药，只能是大于0的数字")
              return
            }
            if(this.deliveryFormData.receiverName.length == 0){
              this.$nextTick(() => {
                this.$refs.nameId.focus();
              })
              this.$message("请输入收件人姓名")
              return
            }
            if(this.deliveryFormData.phoneNo.length == 0){
              this.$nextTick(() => {
                this.$refs.phoneId.focus();
              })
              this.$message("请输入收件人联系方式")
              return
            }
            if(this.addressInfo.length == 0){
              this.$message("请选择省市区")
              return
            }
            if(this.deliveryFormData.street.length == 0){
              this.$nextTick(() => {
                this.$refs.customAddress.focus();
              })
              this.$message("请输入详细地址")
              return
            }
          this.wjtHttp.post(this,'/api/delivery/order/draft/save',{
            deliveryType: "E",
            endDate: this.prescription.endDate,
            form: this.currentForm.formCode,
            formCount: this.drugFormData.drugCount,
            recipientName: this.deliveryFormData.receiverName,
            recipientPhone: this.deliveryFormData.phoneNo,
            recipientAddress: this.deliveryFormData.province+this.deliveryFormData.city+this.deliveryFormData.county+this.deliveryFormData.street,
            province: this.deliveryFormData.province,
            city: this.deliveryFormData.city,
            county: this.deliveryFormData.county,
            street: this.deliveryFormData.street,
            zipCode: this.deliveryFormData.zipCode,
            remark: this.drugFormData.remark,
            startDate: this.prescription.startDate,
            type: this.prescription.type,
            visitRecordId: this.prescription.visitRecordId
          },false,(res)=>{
                  var data = res.data
                  if(data.code == 200){
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'保存草稿成功'
                      })
                  }else{
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'保存草稿异常',
                          type:'error'
                      })
                  }
              },(err)=>{
                  console.log(err)
              })
        }
    },
    destroyed() {
      this.$store.commit('updateFulfillmentConfirmData',{
        drugFormData:this.drugFormData,
        addressInfo:this.addressInfo,
        addressTemp:this.addressTemp,
        currentForm:this.currentForm,
        deliveryFormData:this.deliveryFormData,
      })
      EventBus.$off("address",null)
    },
    beforeRouteLeave(to,from,next){
      if(to.name == 'prescriptionImage'){
        this.$store.commit('updateFulfillmentConfirmData',{})
      }
      next()
    }
  }
</script>

<style scoped>
  .container{
      width: 1160px;
      margin: auto auto;
      display: flex;
      flex-direction: column;
  }
  .page-header{
      width: 1080px;
      margin-top: 30px;
      color: #333333;
      font-size: 20px;
  }
  .page-header >>> div{
      color:#333333;
      font-size: 20px;
  }
  .area-header-one{
      margin-top: 35px;
  }
  .form--item-colomn{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .basic-info{
      width: 985px;
      margin-top: 30px;
      margin-bottom: 15px;
  }
  .basic-info>li{
      color: #333333;
      font-size: 18px;
      text-align: left;
      min-height: 40px;
      width: 100%;
  }
  .dialog-div{
      color: #333333;
      font-size: 18px;
      text-align: left;
      line-height: 28px;
      width: 100%;
      word-wrap: break-word;
      margin-bottom: 16px;
  }
  .table-header{
      background: #156098;
      height: 70px;
      color: white;
      font-size: 18px;
      font-weight: bold;
  }
  .span-index{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 25px;
    height: 25px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 50%;
    border-style: solid;
    border-color: red;
    border-width: 1px;
  }
  .basic-info>li>b{
      font-weight: bold;
  }
  .basic-table{
      margin-left: 35px;
  }
  .table-rows>td{
      height: 50px;
      background: white;
      font-size: 18px;
  }
  .table-footer-td{
      height: 70px;
      background: white;
      font-size: 18px;
      background: #f9f9f9;
      text-align: left;
      padding-left: 30px;
  }
  .table-footer-td>b{
      font-size: 18px;
      color: red;
  }
  .form-item{
      width: 60%;
  }
  .radio-container{
      width: auto;
      height: 36px;
      display: flex;
      flex-direction: row;
      align-items: center;
  }
  .radio-container>span{
      font-size: 18px;
      color: #333333;
  }
  .radio-container>span>b{
      width: 100px;
      font-size: 18px;
      color: #FF2B2B;
      text-align: right;
  }
  .radio-group{
      position: relative;
      right: 125px;
  }
  .radio-button{
      margin: 0 8px;
  }
  .address-picker{
    width: 100%;
  }
  table{
      border-collapse: collapse;  /**设置小表格之间的间距为0*/
      border-right:1px solid #e6e6e6;
      border-top:1px solid #e6e6e6;
  }
  .tabs{
      width: 100%;
      height: auto;
      margin-top: 20px;
      overflow-y: auto;
  }
  .item-row-center{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .item-row{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .item-column{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .collapse-item{
      margin-top: 30px;
  }
  .collapse{
      width: 1050px;
      margin-left: 24px;
  }
  .collapse-hint{
      font-size: 16px;
      color: #cecece;
      position: relative;
      left: 350px;
  }
  .btn-confirm{
      width: 384px;
      border-radius: 40px;
      margin-top: 60px;
      margin-bottom: 60px;
      font-size: 18px;
      height: 45px;
  }
  .dialog-footer{
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/fulfillment/fulfillmentConfirm.vue